import { useStore, View } from '@rehaje/react'
import { observer } from '@rehaje/reactive-react'
import { useMemo } from 'react'

import type { ComponentNode } from './TypedNode'
import type { TypedSpecificLike } from '@rehaje/core'
import type { FC, ReactNode } from 'react'

export interface ElementComponentProps {
  componentId: string
  props?: Record<string, any>
}

export interface ElementComponentSpecific extends TypedSpecificLike {
  children?: ReactNode
  props?: ElementComponentProps
  type: 'Element.Component'
}

export const ElementComponentComponent: FC<ElementComponentProps> = observer(
  ({ children, componentId, props }) => {
    const store = useStore()
    const node = store?.node.find<ComponentNode>(componentId)
    return node ? (
      <View
        store={useMemo(
          () => node.createStore(props, children),
          [node, children]
        )}
      />
    ) : null
  }
)

declare global {
  export interface RehajeSpecifics {
    'Element.Component': ElementComponentSpecific
  }
}
